import { buttonVariants } from "@loot-os/ui/components/button";
import { cn } from "@loot-os/ui/lib/utils";
import { Link } from "@tanstack/react-router";

import type { TemplateAction } from "../pages/shared/links.js";

/** A home action as a button-styled link. */
export function ClassicActionLink({
  action,
  size,
  className,
}: {
  action: TemplateAction;
  size: "sm" | "lg";
  className?: string;
}) {
  return (
    <Link
      to={action.to}
      className={cn(
        buttonVariants({ variant: action.emphasis === "primary" ? "default" : "outline", size }),
        className,
      )}
    >
      {action.label}
    </Link>
  );
}
